export const FILE_VERSION_REGEX = /_v\d+\./;
